import { apiClient } from '../utils/api-client';

interface FundMetrics {
  nav: number;
  totalCommitments: number;
  totalCalled: number;
  totalDistributed: number;
  irr: number;
  dpi: number;
  tvpi: number;
}

export interface RecentActivity {
  id: string;
  type: 'capital_call' | 'distribution' | 'valuation';
  description: string;
  amount?: number;
  currency: string;
  date: string;
  status: string;
  company?: string;
  fund_id?: string;
  entity_id?: string;
}

interface PrepaymentMetrics {
  totalAvailable: number;
  totalContributed: number;
  totalConsumed: number;
  activeInvestorPools: number;
}

interface DashboardMetrics {
  fundMetrics: FundMetrics;
  recentActivity: RecentActivity[];
  prepaymentMetrics: PrepaymentMetrics;
}

class MetricsService {
  private baseUrl = '/metrics';

  async getDashboardMetrics(fundId?: string): Promise<DashboardMetrics> {
    const params = fundId ? { fund_id: fundId } : undefined;
    return apiClient.get<DashboardMetrics>(`${this.baseUrl}/dashboard`, {
      params,
    });
  }

  async getFundMetrics(fundId: string): Promise<FundMetrics> {
    return apiClient.get<FundMetrics>(`${this.baseUrl}/fund/${fundId}`);
  }

  async getRecentActivity(
    fundId?: string,
    limit: number = 10
  ): Promise<RecentActivity[]> {
    const params = {
      ...(fundId && { fund_id: fundId }),
      limit,
    };
    return apiClient.get<RecentActivity[]>(`${this.baseUrl}/activity`, {
      params,
    });
  }

  async getPrepaymentMetrics(): Promise<PrepaymentMetrics> {
    return apiClient.get<PrepaymentMetrics>(`${this.baseUrl}/prepayment`);
  }
}

export const metricsService = new MetricsService();
